<template>
  <div class="editable-text-wrap" @click.stop="edit">
    <el-dropdown v-if="is('dropdown') && editable" trigger="click" @command="mutation">
      <span>
        {{ units[temp] }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(unit, index) in units" :key="unit" :command="index">
          {{ unit }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="text" v-else-if="!editing">{{ temp }}</div>
    <el-input
      v-else-if="is('input') && editable && editing"
      v-focus
      v-model="temp"
      @change="mutation"
    ></el-input>
  </div>
</template>

<script>
import { scheduler, units } from '../utils';
import { v4 } from 'uuid';

const validType = v => ['input', 'dropdown'].includes(v);

export default {
  props: {
    type: {
      validator(v) {
        if (!v) return true;
        return validType(v);
      },
      default: 'input'
    },
    editable: {
      type: Boolean,
      default: false
    },
    target: {
      type: Object,
      default: () => ({})
    },
    prop: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      editing: false,
      id: this.editable && v4(),
      temp: this.target[this.prop],
      units
    };
  },
  methods: {
    is(t) {
      return validType(t) && t === this.type;
    },
    edit() {
      scheduler.exec(this.id);
      if (!this.editable) return;
      scheduler.add(this.id, () => {
        this.editing = false;
      });
      this.editing = true;
    },
    mutation(v) {
      if (!isNaN(v)) v = +v;
      this.$set(this.target, this.prop, v);
      this.temp = v;
    }
  }
};
</script>

<style lang="scss">
.editable-text-wrap {
  min-height: 40px;
  .text,
  .el-dropdown {
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
